import MuiTableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import React from "react";
import { TableBodyColumnSchema } from "../models";
import { TableBodyRow } from "./TableBodyRow";

interface TableBodyProps {
  id?: string;
  columnSchemas: TableBodyColumnSchema[];
  data: any[];
  expandableRowProps?: {
    columnSchemas: TableBodyColumnSchema[];
    keyPropertyName: string;
    dataPropertyName: string;
    expandedKeys: string[];
    onExpandedToggle: (key: string) => void;
  };
  isLoading: boolean;
  loadingText: string;
}

export const TableBodyComponent = (props: TableBodyProps) => {
  const { id, columnSchemas, data, expandableRowProps, isLoading, loadingText } = props;

  return (
    <MuiTableBody id={id}>
      {data.length > 0 ? (
        data.map((rowData, rowIndex) => {
          let expandableProps:
            | {
                data: any;
                columnSchemas: TableBodyColumnSchema[];
                isExpanded: boolean;
                onExpandedToggle: () => void;
              }
            | undefined;

          if (expandableRowProps) {
            const { keyPropertyName, dataPropertyName, expandedKeys, onExpandedToggle } = expandableRowProps;

            const expandableRowKey = rowData[keyPropertyName];
            const expandableRowData = rowData[dataPropertyName];
            const isRowExpanded = expandableRowKey ? expandedKeys.indexOf(expandableRowKey) !== -1 : false;

            const handleExpandedToggle = () => onExpandedToggle(expandableRowKey);

            expandableProps = {
              columnSchemas: expandableRowProps.columnSchemas,
              data: expandableRowData,
              isExpanded: isRowExpanded,
              onExpandedToggle: handleExpandedToggle,
            };
          }

          return (
            <TableBodyRow
              key={`br_${rowIndex}`}
              index={rowIndex}
              data={rowData}
              columnSchemas={columnSchemas}
              expandableProps={expandableProps}
            />
          );
        })
      ) : (
        <TableRow hover={false} tabIndex={-1}>
          <TableCell colSpan={columnSchemas.length} style={{ textAlign: "center" }}>
            {isLoading ? loadingText : "No results to display."}
          </TableCell>
        </TableRow>
      )}
    </MuiTableBody>
  );
};

export const TableBody = TableBodyComponent;
